import {LoginGuard} from './guard'
const routes = [
  {
    path: 'account/login',
    name: 'account/login',
    component: () => import('@/views/account/Login.vue')
  },
  {
    path: 'account/register',
    name: 'account/register',
    component: () => import('@/views/account/register/Register.vue')
  },
  {
    path: 'account/privacy',
    name: 'account/privacy',
    component: () => import('@/views/account/Privacy.vue')
  },
  {
    path: 'account/registerSuccess',
    name: 'account/registerSuccess',
    component: () => import('@/views/account/register/RegisterSuccess.vue')
  },
  {
    path: 'account/password/reback',
    name: 'account/password/reback',
    component: () => import('@/views/account/password/RebackPassWord.vue')
  },
  {
    path: 'account/modify',
    name: 'account/modify',
    component: () => import('@/views/account/ModifyAccount.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/password/change',
    name: 'account/password/change',
    component: () => import('@/views/account/password/ChangePassWord.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/perfect/info',
    name: 'account/perfect/info',
    component: () => import('@/views/account/perfect/Info.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/perfect/accountInfo',
    name: 'account/perfect/accountInfo',
    component: () => import('@/views/account/perfect/accountInfo.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/perfect/status',
    name: 'account/perfect/status',
    component: () => import('@/views/account/perfect/Status.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/role/enterprise',
    name: 'account/role/enterprise',
    component: () => import('@/views/account/role/Enterprise.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/role/government',
    name: 'account/role/government',
    component: () => import('@/views/account/role/Government.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
  {
    path: 'account/role/personal',
    name: 'account/role/personal',
    component: () => import('@/views/account/role/Personal.vue'),
    beforeEnter: (to, from, next) => LoginGuard(to, from, next) && next(),
  },
]

export default routes;
